// extracted by mini-css-extract-plugin
module.exports = {"section":"Partners_section__hZPtD","title":"Partners_title__1amPE","image":"Partners_image__1GuXA","image_mobile":"Partners_image_mobile__3Ayw-"};